import { useCallback, useState } from "react"

interface PendingPickState<Value> {
  storedValue: Value
  pick: Value | null
}

interface PendingPick<Value> {
  value: Value
  setPick: (pick: Value) => void
  clearPick: () => void
}

export function usePendingPick<Value>(storedValue: Value): PendingPick<Value> {
  const [state, setState] = useState<PendingPickState<Value>>({ storedValue, pick: null })

  if (state.storedValue !== storedValue) {
    setState({ storedValue, pick: null })
  }

  const setPick = useCallback((pick: Value) => setState({ storedValue, pick }), [storedValue])
  const clearPick = useCallback(() => setState({ storedValue, pick: null }), [storedValue])

  return { value: state.pick ?? storedValue, setPick, clearPick }
}
